import React, { Component } from "react";
import { Auth } from "aws-amplify";
import { Link } from "react-router-dom";
import { Formik } from 'formik';
import * as Yup from 'yup';
import { Alert } from 'reactstrap';
import {
  Form,
  FormGroup,
  FormControl,
  FormLabel,
  FormText
} from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import "./ResetPassword.css";

var useVerifyValidation = false;

function equalTo(ref: any, msg: any) {
  return Yup.mixed().test({
    name: 'equalTo',
    exclusive: false,
    message: msg || '${path} must be the same as ${reference}',
    params: {
      reference: ref.path,
    },
    test: function (value: any) {
      return value == this.resolve(ref);
    },
  });
}
Yup.addMethod(Yup.string, 'equalTo', equalTo);

const schema = () => {
  if (useVerifyValidation) {
    return Yup.object({
      Email: Yup.string().required()
        .matches(/^[a-zA-Z0-9.!#$%&’'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/, 'Invalid email address'),
      NewPassword: Yup.string().required('New password required.'),
      ConfirmPassword: Yup.string().equalTo(Yup.ref('NewPassword'), 'Passwords must match').required('Confirm password required.'),
      Code: Yup.string().required('Code is required.'),
    });
  }
  else {
    return Yup.object({
      Email: Yup.string().required()
        .matches(/^[a-zA-Z0-9.!#$%&’'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/, 'Invalid email address'),
    });
  }
}

export default class ResetPassword extends Component {
  constructor(props) {
    super(props);

    useVerifyValidation = false;
    this.state = {
      action: "",
      mode: "",
      passwordReset: false,
      isLoading: false,
      alertMessage: "",
      infoMessage: ""
    };
  }

  onDismiss = () => this.setState({ alertMessage: "", infoMessage: "" });

  applyState = (state) => {
    this.setState({ action: state });
  }

  handleSubmit = async event => {

    var action = this.state.action;
    this.setState({ alertMessage: "", infoMessage: "", action: "", email: event.Email, passwordReset: false });

    if (action === "request") {
      try {
        useVerifyValidation = false;
        this.setState({ mode: action });
        this.setState({ isLoading: true });
        await Auth.forgotPassword(event.Email);
        useVerifyValidation = true;
        this.setState({ mode: "validate", infoMessage: "Reset code has been requested and will be sent to your email address." });
      } catch (e) {
        this.setState({ isLoading: false, alertMessage: e.message, infoMessage: "" });
      }
    }

    if (action === "validate") {
      useVerifyValidation = true;
      this.setState({ mode: action });
    }

    if (action === "confirm") {
      this.setState({ mode: action });
      this.setState({ isLoading: true });
      try {
        await Auth.forgotPasswordSubmit(
          event.Email,
          event.Code,
          event.NewPassword
        );
        this.setState({ passwordReset: true });
      } catch (e) {
        this.setState({ isLoading: false, alertMessage: e.message, infoMessage: "" });
      }
    }

    this.setState({ isLoading: false });
  }

  render() {
    return (
      <div className="reset">
        <Formik
          validateOnChange={false}
          validationSchema={schema}
          onSubmit={this.handleSubmit}
          initialValues={{
            Email: '',
            Code: '',
            NewPassword: '',
            ConfirmPassword: '',
          }}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            values,
            touched,
            isValid,
            errors,
          }) => (
              <div>
                <Alert color="warning" isOpen={!this.state.alertMessage == ""} toggle={this.onDismiss} fade={false}>
                  <h4 className="alert-heading">Error</h4>
                  <p>{this.state.alertMessage}</p>
                </Alert>
                <Alert color="info" isOpen={!this.state.infoMessage == ""} toggle={this.onDismiss} fade={false}>
                  <h4 className="alert-heading">Information</h4>
                  <p>{this.state.infoMessage}</p>
                </Alert>

                {this.state.passwordReset ?
                  <div className="main">
                    <div className="content">
                      <h2>Password Reset</h2>
                      <div>Your password has been reset.</div>
                      <Link to="/login">
                        Click here to login with your new credentials.
                   </Link>
                    </div>
                  </div>
                  :
                  <div>
                    <div className="content">
                      <h2>DataStar Reset Login</h2>
                      <div>You can reset your password by requesting a validation code, if you already have a validation code use the validate button.</div>
                    </div>
                    <Form noValidate onSubmit={handleSubmit}>
                      <Form.Group controlId="formBasicEmail">
                        <Form.Label>Email</Form.Label>
                        <Form.Control className="form-control-sm"
                          name="Email"
                          value={values.Email}
                          placeholder="Enter email"
                          type="email"
                          onChange={handleChange}
                          isInvalid={!!errors.Email}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.Email}
                        </Form.Control.Feedback>
                      </Form.Group>
                      {this.state.mode === "validate" ?
                        <div>
                          <FormGroup bsSize="large" controlId="formBasicCode">
                            <FormLabel>Code</FormLabel >
                            <Form.Control className="form-control-sm"
                              name="Code"
                              value={values.Code}
                              placeholder="Enter code"
                              type="text"
                              onChange={handleChange}
                              isInvalid={!!errors.Code}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.Code}
                            </Form.Control.Feedback>
                            <FormText color="muted">
                              Please check your email ({this.state.email}) for the confirmation code.
          </FormText>
                          </FormGroup>
                          <hr />
                          <FormGroup bsSize="large" controlId="formNewPassword">
                            <FormLabel >New Password</FormLabel >
                            <FormControl
                              name="NewPassword"
                              type="password"
                              autoComplete="none"
                              value={values.NewPassword}
                              onChange={handleChange}
                              isInvalid={!!errors.NewPassword}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.NewPassword}
                            </Form.Control.Feedback>
                          </FormGroup>
                          <FormGroup bsSize="large" controlId="formConfirmPassword">
                            <FormLabel >Confirm Password</FormLabel >
                            <FormControl
                              name="ConfirmPassword"
                              type="password"
                              onChange={handleChange}
                              value={values.ConfirmPassword}
                              isInvalid={!!errors.ConfirmPassword}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.ConfirmPassword}
                            </Form.Control.Feedback>
                          </FormGroup>
                        </div>
                        : <div></div>
                      }
                      {this.state.mode !== "validate" ?
                        <div className="buttons">
                          <LoaderButton
                            span
                            name="Request"
                            type="submit"
                            onClick={() => this.applyState("request")}
                            loadingText="Sending…"
                            text="Request"
                            isLoading={this.state.isLoading} />
                          <LoaderButton id="right-button"
                            span
                            name="Validate"
                            type="submit"
                            onClick={() => this.applyState("validate")}
                            text="Validate"
                            isLoading={this.state.isLoading} />
                        </div>
                        : <div className="buttons">
                          <LoaderButton
                            span
                            text="Confirm"
                            onClick={() => this.applyState("confirm")}
                            type="submit"
                            loadingText="Confirm…"
                            isLoading={this.state.isLoading}
                          />
                        </div>
                      }
                    </Form>
                  </div>
                }
              </div>
            )}
        </Formik>
      </div>
    );
  }

}
